module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0024.jpg?v=7016a33c";